import {
  GET_SEND_PRODUCT_REQUEST,
  GET_SEND_PRODUCT_SUCCESS,
  GET_SEND_PRODUCT_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const sendProduct = (token, values) => (dispatch) => {
  dispatch({ type: GET_SEND_PRODUCT_REQUEST });
  const newData = {
    sku: values.sku
};
  return axios({
    method: "POST",
    url: `${BASEURL}create/producttobergen`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData
  })
    .then((response) => {
      return dispatch({
        type: GET_SEND_PRODUCT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SEND_PRODUCT_ERROR,
        payload: [],
      });
    });
};
